import { APIClient } from '@frontend/api-utils';

export class ColliEnumClient extends APIClient {
    public static readonly endpoint = '/colli-api/v1';

    public static async fetchColliStates(): Promise<string[]> {
        const response = await this.fetch(`${this.endpoint}/colli-states`);
        return await this.handleResponse<string[]>(response);
    }

    public static async fetchColliTriggers(): Promise<string[]> {
        const response = await this.fetch(`${this.endpoint}/colli-triggers`);
        return await this.handleResponse<string[]>(response);
    }

    public static async fetchColliActions(): Promise<string[]> {
        const response = await this.fetch(`${this.endpoint}/colli-actions`);
        return await this.handleResponse<string[]>(response);
    }
}
